import styled from 'styled-components';
import { CANBOT_EVALUATION_TYPE } from '../../../constans';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import useAxios from '../../../hooks/useAxios';
import { ICanbotEvaluationClass, IGetCanbotEvaluationClass } from '../../../models/canbot.model';
import { getCanbotEvaluationClass } from '../../../api/canbot.api';
import { useEffect, useState } from 'react';
import { getWebUrl } from '../../../lib/util';

const Block = styled.div`
  .table-custom {
    border-top: 0px;
  }

  .table-link-underline {
    color: #666 !important;
    text-decoration: underline !important;
  }
`;

interface IProps {
    classCode: string;
}

const CanbotReport = ({classCode} : IProps) => {

    const { t, i18n } = useTranslation();
    const { chosenClass } = useSelector((state: RootState) => state.class);
    const { data: res, isLoading, error, execute } = useAxios<IGetCanbotEvaluationClass>();

    const [evaluationList, setEvaluationList] = useState<ICanbotEvaluationClass[]>();

    useEffect(() => {
        execute(getCanbotEvaluationClass(classCode));
    }, [classCode]);

    useEffect(() => {
        if (res && res.data) {
          setEvaluationList(res.data); // 배열로 저장
        }
    }, [res]);

    const progressReportOpen = (resultCode: number, memberCode: string, type: string) => {
        window.open(`${getWebUrl()}/report/canbot-report-card?classCode=${classCode}&memberCode=${memberCode}&reportTypeCode=${type}`, '_blank', 'width=1090, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=yes');
    }

    return (
        <Block>
            <div className="comm-bx__between"><h3 className="sub-title">Hey, CANBot! Report {'> ' + chosenClass?.className}</h3></div>
            <div className="sc-hIUJlX kfjbBJ comm-table__area mt-0">
                <table className="table-custom no-hover">
                    <colgroup>
                        <col width="4%" />
                        <col width="13%" />
                        <col width="16%" />
                        <col width="9%" />
                        <col width="9%" />
                        <col width="9%" />
                        <col width="9%" />
                        <col width="9%" />
                        <col width="9%" />
                        <col width="13%" />
                    </colgroup>
                    <thead>
                        <tr>
                        <th className="text-center" rowSpan={2}>No</th>
                        <th className="text-center" rowSpan={2}>{t('class.class.column74')}</th>
                        <th className="text-center" rowSpan={2}>{t('class.canbot.label1')}</th>
                        <th className="text-center" colSpan={6}>Unit</th>
                        <th className="text-center" rowSpan={2}>Progress report</th>
                        </tr>
                        <tr>
                        <th className="text-center">U1</th>
                        <th className="text-center">U2</th>
                        <th className="text-center">U3</th>
                        <th className="text-center">U4</th>
                        <th className="text-center">U5</th>
                        <th className="text-center">U6</th>
                        </tr>
                    </thead>
                    <tbody>
                    {evaluationList && evaluationList.map((student, idx) => 
                        student.skillScores.map((skill, skillIdx) => (
                            <tr key={`${student.memberCode}_${skill.skillCode}`}>
                            {/* 첫 번째 스킬 row에만 No, 이름, Progress report 출력 (rowSpan 활용) */}
                            {skillIdx === 0 && (
                                <>
                                <td className="text-center" rowSpan={student.skillScores.length}>{idx + 1}</td>
                                <td className="text-center" rowSpan={student.skillScores.length}>
                                    {student.memberName}
                                </td>
                                </>
                            )}
                            <td className="text-center">{skill.skillName}</td>
                            <td className="text-center">{skill.unit1}</td>
                            <td className="text-center">{skill.unit2}</td>
                            <td className="text-center">{skill.unit3}</td>
                            <td className="text-center">{skill.unit4}</td>
                            <td className="text-center">{skill.unit5}</td>
                            <td className="text-center">{skill.unit6}</td>
                            {/* 첫 번째 스킬 row에만 Progress report 출력 (rowSpan 활용) */}
                            {skillIdx === 0 && (
                                <td className="text-center" rowSpan={student.skillScores.length}>
                                    {student.prCnt >= 1 && (<a className="table-link-underline" href="#none" onClick={()=> progressReportOpen(student.resultCode, student.memberCode,'PR')}>Units 1-3</a>)}
                                    {student.ptCnt >= 1 && (<><br /><br /><a className="table-link-underline" href="#none" onClick={()=> progressReportOpen(student.resultCode, student.memberCode,'PT')}>Units 1-6</a></>)}
                                </td>
                            )}
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </Block>
    );
}

export default CanbotReport;